export class InvoiceLineItem {
    quantity: number = 0.00;
    description?: string;
    rate: number = 0.00;
    amount: number = 0.00;
    title?: string; 
    image?: string;
    tax: number = 0.00; 
}